var WebPush = {
    DELAY: 120,
    TIMEOUT_COUNT: 10
};
export default WebPush;
